// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1888":"9859d9af","2173":"a1ae10cb","6757":"976aae30"}[chunkId] + ".chunk.css";
};